import { render, staticRenderFns } from "./CreateProductType.vue?vue&type=template&id=3ff36ffe&lang=pug&"
import script from "./CreateProductType.vue?vue&type=script&lang=ts&"
export * from "./CreateProductType.vue?vue&type=script&lang=ts&"
import style0 from "./CreateProductType.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports